export function money(n){
  const v = Number(n || 0);
  return v.toLocaleString("es-EC", { style:"currency", currency:"USD" });
}
export function num(n){
  return Number(n || 0).toLocaleString("es-EC");
}
export function pct(n){
  return `${Number(n || 0).toFixed(2)}%`;
}
